/**
 * Utility functions for calculating brand color styles
 */

import { isDark, isWhiteOrNearWhite } from './jobDetailUtils';
import { TYOMARKKINATORI_PURPLE, DEFAULT_BRAND_GREEN } from './constants';

export interface BrandStyleOptions {
  brandColour?: string;
  isTyomarkkinatori?: boolean;
}

export interface BrandStyles {
  effectiveBrandColour: string;
  useBrandColor: boolean;
  leftBorderStyle: React.CSSProperties;
  applyBtnStyle: React.CSSProperties;
  applyBtnHoverStyle: React.CSSProperties;
  activeTabStyle: React.CSSProperties;
  savedIconStyle: React.CSSProperties;
}

/**
 * Calculate all brand-related styles based on brand color and job type
 */
export function calculateBrandStyles(options: BrandStyleOptions): BrandStyles {
  const { brandColour, isTyomarkkinatori } = options;
  
  // Use tyomarkkinatori purple for tyomarkkinatori jobs
  const effectiveBrandColour = isTyomarkkinatori ? TYOMARKKINATORI_PURPLE : brandColour;
  const useBrandColor = effectiveBrandColour && !isWhiteOrNearWhite(effectiveBrandColour);

  const leftBorderStyle = useBrandColor ? { borderLeft: `4px solid ${effectiveBrandColour}` } : {};
  
  const applyBtnStyle = useBrandColor
    ? {
        backgroundColor: effectiveBrandColour,
        color: isDark(effectiveBrandColour) ? '#fff' : '#111827',
        border: 'none',
      }
    : {
        backgroundColor: DEFAULT_BRAND_GREEN,
        color: '#fff',
        border: 'none',
      };
  
  const applyBtnHoverStyle = useBrandColor
    ? {
        backgroundColor: effectiveBrandColour,
        filter: 'brightness(0.92)',
      }
    : {
        backgroundColor: DEFAULT_BRAND_GREEN,
        filter: 'brightness(0.92)',
      };
  
  const activeTabStyle = useBrandColor
    ? {
        borderBottom: `2px solid ${effectiveBrandColour}`,
      }
    : {
        borderBottom: `2px solid ${DEFAULT_BRAND_GREEN}`,
      };
  
  const savedIconStyle = useBrandColor 
    ? { color: effectiveBrandColour } 
    : { color: DEFAULT_BRAND_GREEN };

  return {
    effectiveBrandColour: effectiveBrandColour || DEFAULT_BRAND_GREEN,
    useBrandColor: !!useBrandColor,
    leftBorderStyle,
    applyBtnStyle,
    applyBtnHoverStyle,
    activeTabStyle,
    savedIconStyle,
  };
}
